import styled from 'styled-components';

export const SkewedButton = styled.div`
  display: inline-block;
  padding: 0 20px 0 10px;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  height: 100%;
  margin-left: ${props => !props.first && '6px'};
  min-width: ${({ minWidth }) => (minWidth !== '' && minWidth)};

  &:after {
    content: '';
    background: ${props => props.theme.backgroundColor};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 2px solid ${props => props.theme.borderColor};
    border-width: 2px 2px 2px 0;
    border-bottom: ${props => props.active && `4px solid ${props.theme.iconColor}`};
    transform: ${(props) => {
    if (props.first) {
      return 'skewX(20deg)';
    } else if (props.last) {
      return 'skewX(0deg)';
    }
    return 'skewX(20deg)';
  }};
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -9px;
    bottom: 0;
    width: 16px;
    border: 2px solid ${props => props.theme.borderColor};
    border-width: 2px 0 2px 2px;
    border-bottom: ${props => props.active && `4px solid ${props.theme.iconColor}`};
    background: ${props => props.theme.backgroundColor};
    z-index: 8;
    transform: ${(props) => {
    if (props.last) {
      return 'skewX(20deg)';
    } else if (props.first) {
      return 'skewX(0deg)';
    }
    return 'skewX(20deg)';
  }};
  }

  }
`;
